/**
 * Blocks adding a product to the cart if it is already present.
 * Patches window.fetch to intercept all /cart/add.js calls — covers
 * product pages (FormData body), quick-add, and the upsell buttons (JSON body).
 */
(function () {
  if (window.LimitOnePerProduct) return;
  window.LimitOnePerProduct = true;

  var _fetch = window.fetch;

  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      return checkThenAdd(resource, init);
    }
    return _fetch.apply(this, arguments);
  };

  function checkThenAdd(resource, init) {
    if (window._undoInProgress) return _fetch.apply(window, [resource, init]);
    var variantId = 0;

    if (init && init.body instanceof FormData) {
      variantId = Number(init.body.get('id'));
    } else {
      var body = {};
      try { body = JSON.parse((init && init.body) || '{}'); } catch (e) {}
      variantId = Number(body.id || (body.items && body.items[0] && body.items[0].id));
    }

    if (!variantId) return _fetch.apply(window, [resource, init]);

    return _fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items.some(function (item) { return item.variant_id === variantId; });
        if (!inCart) return _fetch.apply(window, [resource, init]);
        // Return a 422 that matches Shopify's error format so Dawn shows it inline
        return new Response(
          JSON.stringify({ status: 422, message: 'Cart Error', description: 'Already in cart' }),
          { status: 422, headers: { 'Content-Type': 'application/json' } }
        );
      })
      .catch(function () { return _fetch.apply(window, [resource, init]); });
  }
})();
